import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
import { useEditTaskMutation } from "../../redux/features/tasks/taskApi"


export default function EditForm({task, team, projects}){
  
    const navigate = useNavigate()
    const [editTask, {isLoading, isError, isSuccess}] = useEditTaskMutation();

    // input state
    const [input, setInput] = useState(task)

// input change handler 
const changeHandler = (e)=>{
    switch(e.target.name){
        case "teamMember":
            setInput(prev=>({
                ...prev,
                teamMember: JSON.parse(e.target.value)
            }))
            break
            case "projectName":
                setInput(prev=>({
                    ...prev,
                    project: JSON.parse(e.target.value)
                }))
                break
            default:
                setInput(prev=>({
                    ...prev,
                    [e.target.name]: e.target.value
                }))
    }
}


const handleSubmit =(e)=>{
    e.preventDefault();
    editTask({id: task.id, data: input})
}


useEffect(()=>{
    if(isSuccess){ navigate("/") }
},[isSuccess, navigate])

  return(
    <form className="space-y-6" onSubmit={handleSubmit}>
            <div className="fieldContainer">
              <label htmlFor="lws-taskName">Task Name</label>
              <input
                type="text"
                name="taskName"
                id="lws-taskName"
                required
                placeholder="Implement RTK Query"
                value={input.taskName}
                onChange={changeHandler}
              />
            </div>

            <div className="fieldContainer">
              <label>Assign To</label>
              <select name="teamMember" id="lws-teamMember" required
              value={JSON.stringify(input.teamMember)}
              onChange={changeHandler}
              >
                <option value="" hidden>Select Job</option>
                {team.map(item=><option value={JSON.stringify(item)} key={item.id}>{item.name}</option>)}
              </select>
            </div>
            <div className="fieldContainer">
              <label htmlFor="lws-projectName">Project Name</label>
              <select id="lws-projectName" name="projectName" required
              value={JSON.stringify(input.project)}
              onChange={changeHandler}
              >
                <option value="" hidden>Select Project</option>
                {projects.map(item=><option value={JSON.stringify(item)} key={item.id}>{item.projectName} </option>)}
              </select>
            </div>

            <div className="fieldContainer">
              <label htmlFor="lws-deadline">Deadline</label>
              <input type="date" name="deadline" id="lws-deadline" required 
              value={input.deadline}
              onChange={changeHandler}
              />
            </div>

            <div className="text-right">
              <button type="submit" className="lws-submit" disabled={isLoading}>Save</button>
            </div>
            {isError && <div className="errorClass">There was an Editing error</div>}
          </form>
  )};